import { defineComponent as _defineComponent } from 'vue'
import ChartLegend from './ChartLegend.vue';
import SliderInput from 'ah-common-lib/src/common/components/SliderInput.vue';
import ValidatedForm from 'ah-common-lib/src/form/components/formComponents/ValidatedForm.vue';
import { FormDefinition } from 'ah-common-lib/src/form/interfaces';
import { VCol } from 'ah-common-lib/src/common/components';
import { VRow } from 'ah-common-lib/src/common/components';
import { computed, ref, watch } from 'vue';
import { financialAmountField } from 'ah-common-lib/src/form/models';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { makeFormModel } from 'ah-common-lib/src/form/helpers';
import { required } from '@vuelidate/validators';


export default /*#__PURE__*/_defineComponent({
  __name: 'SpotLimitsEditor',
  props: {
  currency: {
    type: String,
    default: 'GBP',
  },
  requestedSpotLimitsAmount: {
    type: Number,
    required: true,
  },
  currentLimit: {
    type: Number,
    required: true,
  },
  utilisedLimit: {
    type: Number,
    required: true,
  },
},
  emits: {
  'update:requestedSpotLimitsAmount': (_payload: number) => true,
  'update:validation': (_payload: boolean) => true,
},
  setup(__props, { emit }) {

const props = __props;

const DEFAULT_ALLOWED_LIMIT_VALUES = {
  min: 0,
  max: 2500000,
};

/**
 * For now hardcoding the colors, this will be discussed with the design team
 * to see if we keep the color ranges or not and if they are hardcoded or themed colors
 */
const CHART_LEGEND_DATA = [
  { color: '#00272d', label: 'Utilised Limit' },
  { color: '#bce4f3', label: 'Current Limit' },
  { color: '#39a2b1', label: 'Requested Limit' },
];





const selectedAmount = ref<number>(props.requestedSpotLimitsAmount);

const dynamicMaxLimit = computed(() => {
  return Math.max(props.utilisedLimit, props.currentLimit, selectedAmount.value, DEFAULT_ALLOWED_LIMIT_VALUES.max);
});

const utilizedLimitSliderPercentage = computed(() => (props.utilisedLimit * 100) / dynamicMaxLimit.value);

const currentLimitSliderPercentage = computed(() => {
  if (props.utilisedLimit > props.currentLimit) {
    return (props.currentLimit * 100) / dynamicMaxLimit.value;
  }
  return ((props.currentLimit - props.utilisedLimit) * 100) / dynamicMaxLimit.value;
});

const spotLimitsFormDef = ref<FormDefinition>({
  form: makeFormModel({
    name: 'spotLimitsForm',
    fieldType: 'form',
    fields: [
      financialAmountField(
        'amount',
        '',
        {
          fieldWrapperClass: 'col-4',
          defaultValue: props.requestedSpotLimitsAmount,
          errorMessages: {
            required: 'Value must be equal to or greater than 0',
          },
        },
        {
          required,
        }
      ),
    ],
  }),
  validation: null,
});

watch(
  () => spotLimitsFormDef.value.form.amount,
  (newAmount) => {
    if (spotLimitsFormDef.value.validation?.$invalid === false) {
      selectedAmount.value = newAmount;
      emit('update:requestedSpotLimitsAmount', newAmount);
    }
  }
);

watch(
  () => spotLimitsFormDef.value.validation?.$invalid,
  (invalid) => emit('update:validation', !!invalid),
  { immediate: true }
);

return { __sfc: true,DEFAULT_ALLOWED_LIMIT_VALUES, CHART_LEGEND_DATA, props, emit, selectedAmount, dynamicMaxLimit, utilizedLimitSliderPercentage, currentLimitSliderPercentage, spotLimitsFormDef, ChartLegend, SliderInput, ValidatedForm, VCol, VRow, formatCurrencyValue }
}

})